module.exports = __webpack_public_path__ + "img/immersion-button.1a94c9b1.png";